<template>
  <div>
    <DepartmentHeader @create="openCreateModal" />
    <DepartmentTable
      :headers="headers"
      :departments="filteredDepartments"
      :loading="isLoading"
      @edit="openEditModal"
      @delete="confirmDelete"
    />
    <DepartmentDialog
      :dialog="showModal"
      :formTitle="formTitle"
      :editedItem="formData"
      @close="closeModal"
      @save="submitForm"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import DepartmentHeader from '@/modules/department/DepartmentHeader.vue'
import DepartmentTable from '@/modules/department/DepartmentTable.vue'
import DepartmentDialog from '@/modules/department/DepartmentDialog.vue'

export default {
  components: {
    DepartmentHeader,
    DepartmentTable,
    DepartmentDialog,
  },
  data() {
    return {
      searchQuery: '',
      showModal: false,
      isEditing: false,
      formData: {
        title: '',
        description: ''
      },
      headers: [
        { text: 'Tên cơ sở', value: 'title' },
        { text: 'Địa chỉ', value: 'description' },
        { text: 'Thao tác', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState('department', ['departments', 'loading', 'error']),
    ...mapGetters('department', ['isLoading', 'getError']),
    filteredDepartments() {
      if (!this.departments) return []
      return this.departments.filter(dept => 
        dept.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        dept.description.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    },
    formTitle() {
      return this.isEditing ? 'Sửa cơ sở' : 'Thêm cơ sở mới'
    }
  },
  methods: {
    ...mapActions('department', ['fetchDepartments', 'createDepartment', 'updateDepartment', 'deleteDepartment']),
    openCreateModal() {
      this.isEditing = false
      this.formData = { title: '', description: '' }
      this.showModal = true
    },
    openEditModal(department) {
      this.isEditing = true
      this.formData = { ...department }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.$nextTick(() => {
        this.formData = { title: '', description: '' }
        this.isEditing = false
      })
    },
    async submitForm() {
      try {
        if (this.isEditing) {
          await this.updateDepartment({ id: this.formData.id, params: this.formData })
        } else {
          await this.createDepartment(this.formData)
        }
        this.closeModal()
        this.fetchDepartments()
      } catch (error) {
        console.error('Error submitting form:', error)
      }
    },
    async confirmDelete(department) {
      if (confirm('Bạn có chắc chắn muốn xóa cơ sở này?')) {
        try {
          await this.deleteDepartment(department.id)
          this.fetchDepartments()
        } catch (error) {
          console.error('Error deleting department:', error)
        }
      }
    }
  },
  created() {
    this.fetchDepartments()
  }
}
</script>

<style scoped>
.v-data-table {
  margin-top: 20px;
}
</style>